import { useNavigate } from 'react-router';

import { ANY_SPORT_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { QuickPlayTutorialDialog } from '@sorare/gameplay/src/components/quickPlay/QuickPlayTutorialDialog';

const QuickPlayTutorialPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { isIosApp, postMessage } = useIsMobileApp();
  const navigate = useNavigate();

  return (
    <QuickPlayTutorialDialog
      open
      onClose={() => {
        if (isIosApp) {
          postMessage('closeCurrentWebview');
        } else {
          navigate(generateSportContextPath(ANY_SPORT_HOME));
        }
      }}
    />
  );
};
export default QuickPlayTutorialPage;
